/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_ConnectInputs */

const en_dropbox_connect = /** @type {(inputs: Dropbox_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Dropbox`)
};

const es_dropbox_connect = /** @type {(inputs: Dropbox_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectar Dropbox`)
};

/**
* | output |
* | --- |
* | "Connect Dropbox" |
*
* @param {Dropbox_ConnectInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_connect = /** @type {((inputs?: Dropbox_ConnectInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_ConnectInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_connect(inputs)
	return en_dropbox_connect(inputs)
});